module.exports = __webpack_public_path__ + "static/media/cateModaH.bf7b27f2.jpg";